import { useEffect, useState } from "react";
import { fetchPublicUniversitiesCatalogue } from "../../../service/catalogues";

/**
 * @param {import("react").PropsWithChildren<HTMLInputElement>} props
 */
export default function PublicUniversityInput({ className, ...props }) {
    const [publicUniversities, setPublicUniversities] = useState(/** @type {string[]} */ ([]));

    async function fetchPublicUniversities() {
        try {
            let catalogue = await fetchPublicUniversitiesCatalogue()

            if (catalogue && catalogue.values) {
                setPublicUniversities(catalogue.values);
            }
        } catch (error) {
            console.log(`Error fetching public universities: ${JSON.stringify(error)}`);
        }
    }

    useEffect(() => {
        let isMounted = true;

        if (isMounted) {
            fetchPublicUniversities();
        }

        return () => { isMounted = false; }
    }, []);

    return (
        <>
            <input type="text" className={`${className} form-control`} {...props} list="public_universities"  />
            <datalist id="public_universities">
                {publicUniversities.map(university => {
                    return (<option value={university}> {university} </option>);
                })}
            </datalist>
        </>
    )
}